/**
 * Convert snake_case string into Capitalized string
 * @param {String} str
 */
export const snakeToCapitalized = (str) => (
  str.split('_').map((word) => word[0].toUpperCase() + word.substring(1)).join(' ')
);
